import React from 'react';

import {FlowchartNode} from '../processFlowchartConfigEditorNodeTypes';
import {FlowchartSidepanelManagerContext} from './FlowchartSidepanelUnsavedChangesContext';
import useFlowchartSidepanelManager from './useFlowchartSidepanelManager';

export interface FlowchartSidepanelManagerProps {
  getNodeById: (nodeId: string) => FlowchartNode | null;
  children: React.ReactNode;
}

/**
 * Manages the sidepanel state for the flowchart config editor.
 *
 * Convenience wrapper around useFlowchartSidepanelManager to provide the context value to the children.
 *
 * @param props.getNodeById - A function to get a flowchart node by its ID.
 * @param props.children - The children to render.
 */
export default function FlowchartSidepanelManager(props: FlowchartSidepanelManagerProps): JSX.Element {
  const sidepanelManager = useFlowchartSidepanelManager(props.getNodeById);
  const sidepanelManagerContextValue = React.useMemo(() => sidepanelManager, [sidepanelManager]);

  return (
    <FlowchartSidepanelManagerContext.Provider value={sidepanelManagerContextValue}>
      {props.children}
    </FlowchartSidepanelManagerContext.Provider>
  );
}
